import React, { useState } from 'react';
import { validEmailRe } from '../../../constant';

// Custom hook for affiliate form management
export const useAffiliateForm = (onAddAffiliate) => {
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        email: '',
    });
    const [isLoading, setIsLoading] = useState(false);

    const validateForm = () => {
        let isValid = true;
        let errorsObj = {};

        // Email format validation only if provided
        if (formData.email && !validEmailRe.test(formData.email)) {
            isValid = false;
            errorsObj.email = 'Enter valid email address';
        }

        setErrors(errorsObj);
        return isValid;
    };

    const onFieldChange = event => {
        let { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const resetForm = () => {
        setFormData({ email: '' });
        setErrors({});
    };

    const handleAddAffiliate = async () => {
        if (validateForm()) {
            try {
                setIsLoading(true);
                await onAddAffiliate({ email: formData.email || null });
                resetForm();
            } finally {
                setIsLoading(false);
            }
        }
    };

    return {
        formData,
        errors,
        isLoading,
        onFieldChange,
        handleAddAffiliate,
        resetForm,
    };
};
